import * as React from "react";
import {Address} from "../../models/Address";
import {ShoppingBasket} from "../../models/ShoppingBasket";
import {Address as AddressEditor} from "../common/Address";
import {ReadonlyAddress} from "../common/ReadonlyAddress";
import {Button} from "../common/Button";
import {CollapsiblePanel} from "../common/CollapsiblePanel";
import {ModalDialog, ModalBody, ModalFooter } from "../common/ModalDialog";
import update = require("react-addons-update");
import ShoppingBasketStore from "../../stores/ShoppingBasketStore";
import AddressBookDialogStore from "../../stores/AddressBookDialogStore";
import FBEmitter = require("fbemitter");
export interface AddressBookDialogProps
{
	shoppingBasket: ShoppingBasket;
	title: string;
	addressType: "ship" | "bill";
	phoneRequired: boolean;
}
export interface AddressBookDialogState
{
	isDialogOpen:boolean;
	isCreatePanelOpen: boolean;
	newAddress?: Address;
	selectedAddress?: Address;
	validationState: {
		newAddressLine1Valid: boolean;
		newAddressCityValid: boolean;
		newAddressStateValid: boolean;
		newAddressPostalValid: boolean;
		newAddressPhoneValid: boolean;
		newAddressFirstNameValid: boolean;
		newAddressLastNameValid: boolean;
		isValid: boolean;
	},
	shouldValidate: boolean;
	
}

export class AddressBookDialog extends React.Component<AddressBookDialogProps, AddressBookDialogState>
{
	
	state: AddressBookDialogState = {
		isCreatePanelOpen: false,
		isDialogOpen: false,
		validationState: {
			newAddressLine1Valid: false,
			newAddressCityValid: false,
			newAddressStateValid: false,
			newAddressPostalValid: false,
			newAddressPhoneValid: false,
			newAddressFirstNameValid: false,
			newAddressLastNameValid: false,
			isValid:false
		},
		shouldValidate: false
	}
	dialogStoreRegistration: FBEmitter.EventSubscription;
	
	render() { return this.renderChangeShippingAddressDialog(); }
	private renderChangeShippingAddressDialog()
	{
		const addresses = this.props.shoppingBasket.customer.addresses;

		return <ModalDialog title={this.props.title} open={this.state.isDialogOpen}>
			       <ModalBody>
				       <table className="table">
					       <tbody>
					       {addresses.map((address, i) =>
						{
							return <tr key={i}>
								<td>
									<div  className="radio">
										<label>
											<input type="radio" name="shippingAddressPicker" onClick={() =>
											{
												this.setState(update(this.state, { $set: { selectedAddress: address } }));
											} }/>
											<ReadonlyAddress address={address}/>
										</label>&nbsp;
									</div>
								</td>
								<td>
									<a className="btn btn-danger" href="#" onClick={() => this.removeAddress(address) } >Remove</a>
								</td>
							</tr>
								;
						}) }
					       </tbody>
				       </table>
				       <a href="#" onClick={() => { this.openCreateShippingAddress(true) } }>Create new Address</a>
				       <CollapsiblePanel title="Create New Address" isOpened={this.state.isCreatePanelOpen}>
					       <AddressEditor fieldName="addressEditor" shouldTriggerValidation={this.state.shouldValidate} phoneRequired={this.props.phoneRequired} addressUpdated={this.captureNewAddress.bind(this) }/>
					       <Button label="Create Address" onClick={this.createAddress.bind(this) }/>
					       <Button label="Cancel" className="muted" onClick={() =>
					{
						this.openCreateShippingAddress(false);
					} }/>
				       </CollapsiblePanel>
			       </ModalBody>
			       <ModalFooter>
				       <Button label="Select Address" progressLabel="Selecting Address..." onClick={() =>
				{
					if (!this.state.isCreatePanelOpen && this.state.selectedAddress)
					{
						if(!this.validateSelectedAddress(this.state.selectedAddress))
						{
							alert("This address no longer meets our requirements, please recreate it");
							return;
						}
						return ShoppingBasketStore.assignPerferredAddress(this.state.selectedAddress, this.props.addressType).done(() =>
						{
							this.openAddressDialog(false);
						});
					}
					return null;
				} }/>
				       <Button label="Cancel" className="muted" onClick={() =>
				{
					this.openAddressDialog(false);
				} }/>
			       </ModalFooter>
		       </ModalDialog>;
	}

	private validateSelectedAddress(address:Address)
	{
		var isValid = true;
		if (address.line1 === "")
		{
			isValid = false;
		}
		if (address.city === "")
		{
			isValid = false;
		}
		if (address.stateProvince === "")
		{
			isValid = false;
		}
		if (address.postalCode === "")
		{
			isValid = false;
		}
		if (this.props.phoneRequired && address.phoneNumber === "")
		{
			isValid = false;
		}
		if (address.person.first === "")
		{
			isValid = false;
		}
		if (address.person.last === "")
		{
			isValid = false;
		}
		return isValid;
	}
	private captureNewAddress(address: Address)
	{
		this.setState(update(this.state, { $set: { newAddress: address } }));
	}
	private openCreateShippingAddress(open: boolean)
	{
		this.setState(update(this.state, { $set: { isCreatePanelOpen: open } }));
	}

	removeAddress(address: Address): any
	{
		if (confirm("Are you sure you want to remove address from your address book"))
		{
			ShoppingBasketStore.removeAddressFromCustomer(address);
		}
	}

	createAddress()
	{

		var validationState = this.isValid();
		if (validationState.isValid)
		{
			return ShoppingBasketStore.addAddressToCustomer(this.state.newAddress).done(() =>
			{
				this.openCreateShippingAddress(false);
			});
		}
		else
		{
			this.setState(update(this.state, { $set: { validationState: validationState, shouldValidate: true } }));
			alert("You must fill out the form");	
		}
		return null;
	}

	private isValid()
	{
		var isValid = true;
		var validationState =
			 {
				newAddressLine1Valid: true,
				newAddressCityValid: true,
				newAddressStateValid: true,
				newAddressPostalValid: true,
				newAddressPhoneValid: true,
				newAddressFirstNameValid: true,
				newAddressLastNameValid: true,
				isValid: true
			};
		var address = this.state.newAddress;
		if (address.line1 === "")
		{
			isValid = false;
			validationState.newAddressLine1Valid = false;
		}
		if (address.city === "")
		{
			isValid = false;
			validationState.newAddressCityValid = false;
		}
		if (address.stateProvince === "")
		{
			isValid = false;
			validationState.newAddressStateValid = false;
		}
		if (address.postalCode === "")
		{
			isValid = false;
			validationState.newAddressPostalValid = false;
		}
		if (this.props.phoneRequired && address.phoneNumber === "")
		{
			isValid = false;
			validationState.newAddressPhoneValid = false;
		}
		if (address.person.first === "")
		{
			isValid = false;
			validationState.newAddressFirstNameValid = false;
		}
		if (address.person.last === "")
		{
			isValid = false;
			validationState.newAddressLastNameValid = false;
		}
		validationState.isValid = isValid;
		return validationState;
	}

	private openAddressDialog(state: boolean)
	{
		AddressBookDialogStore.openDialog(this.props.addressType,state);
	}

	componentWillMount(): void
	{
		this.dialogStoreRegistration = AddressBookDialogStore.addListener(this.checkDialogState.bind(this));
	}
	private checkDialogState()
	{
		this.setState(update(this.state, { $set: { isDialogOpen: AddressBookDialogStore.isDialogOpen(this.props.addressType) } }));
		
	}
}


// WEBPACK FOOTER //
// ./src/components/shoppingbasket/AddressBookDialog.tsx